import Section from '../Section';
import MobileMenu from '../global/MobileMenu';
import PredictiveSearch from '../global/PredictiveSearch';
import Helpers from '../modules/Helpers';

export default class Header extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);
    this.element = element;

    this.previousScrollPosition = 0;

    this.loadStickyHeader();
    this.mobileMenu = new MobileMenu(
      theme,
      document.querySelector('.mobile-menu-wrapper')
    );
    this.predictiveSearch = new PredictiveSearch(theme, element);
    this.loadDropdownHover();
    this.headerLinkHandle();
    this.fixHeaderHeight();
    this.setSearchWidth();
    this.updateOverlayHeader();

    this.theme.loadIcons();

    var self = this;
    window.addEventListener('resize', function () {
      self.setSearchWidth();
    })

    document.addEventListener('shopify:section:reorder', this.updateOverlayHeader);
  }

  onSectionSelect = ({ element, sectionId, load }) => {
    this.theme.loadDrawers();
  };

  onBlockSelect = ({ element }) => {
    // Enable hover to use proper menu colors
    this.element.classList.add('touch-hover');

    // Open megamenu which is being edited (both normal menu and sticky menu)
    if (element.dataset.megaMenuBlockId) {
      var thisElement = document.querySelector(
        `.header-menu-wrapper [data-mega-menu-block-id="${element.dataset.megaMenuBlockId}"]`
      );
      const menu = thisElement.closest(
        'li.dropdown > .mega-menu--dropdown-wrapper'
      );
      const handler = menu.querySelector('.dropdown-fresh-toggle');

      this.openMenu(menu, handler, true);
    }
  };

  onBlockDeselect = () => {
    // Disable hover
    this.element.classList.remove('touch-hover');

    // Close opened megamenus
    let openMenus = document.querySelectorAll(
      '.mega-menu--dropdown-wrapper.force-open'
    );

    openMenus.forEach((openMenu) => {
      let openMenuSubOpen = openMenu.querySelectorAll(
        'a[aria-expanded="true"]'
      );

      openMenuSubOpen.forEach((subOpen) => {
        subOpen.setAttribute('aria-expanded', 'false');
      });

      openMenu.classList.remove('force-open');
    });
  };

  updateOverlayHeader = () => {
    let getIndexSections = document.querySelector('.index-sections');
    let getOverlayHeader = document.querySelector('.overlay--active');

    if (!getIndexSections || !getOverlayHeader) return;

    let getFirstSection = getIndexSections.firstElementChild;
    let isSlideshow = getFirstSection.classList.contains('homepage-section--slideshow-wrapper');
    let isImage = getFirstSection.classList.contains('homepage-section--image');
    let isImageWithText = getFirstSection.classList.contains('homepage-section--text-over-image-wrapper');
    let isImageWithTextBlock = getFirstSection.classList.contains('homepage-section-image-with-text-block--wrapper');

    if (isSlideshow || isImage || isImageWithText || isImageWithTextBlock) {
      getOverlayHeader.classList.add('header-wrapper--overlay');
    } else {
      getOverlayHeader.classList.remove('header-wrapper--overlay');
    }
  }

  updateStickyHeader = () => {
    // How many pixel below the menu should the sticky menu appear
    const menu_breakpoint_offset = 50;

    // breakpoint is where the sticky menu should appear = menu bottom + 50px
    const menu_breakpoint =
      this.element.clientTop +
      this.element.clientHeight +
      menu_breakpoint_offset;

    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    const showOnScrollUp = this.element.classList.contains('sticky-scroll-up');
    const showOnScroll = showOnScrollUp ? scrollTop < this.previousScrollPosition : true;

    const isSticky = scrollTop > menu_breakpoint && showOnScroll;

    const hasResults = this.element.querySelector('#top-search-wrapper').classList.contains('has-results');
    const resultsPanel = this.element.querySelector('.search-results-panel');
    let resultsHidden = resultsPanel ? resultsPanel.classList.contains('hide') : true;

    const searchResultsOpen = hasResults && !resultsHidden;

    if (isSticky && !searchResultsOpen) {
      this.sticky.classList.add('sticky');
      this.sticky.parentElement.classList.remove('unstuck');
      this.sticky.parentElement.classList.add('stuck');
      this.sticky.parentElement.classList.remove('header-search--expanded');
      setTimeout(function () {
        const langSelectorSticky = document.querySelector('.stuck .sticky-desktop-header #header_localization_form_language_selector-button');
        const currencySelectorSticky = document.querySelector('.stuck .sticky-desktop-header #header_localization_form_currency_selector-button');

        if (langSelectorSticky) {
          langSelectorSticky.setAttribute('tabIndex', '0');
        }

        if (currencySelectorSticky) {
          currencySelectorSticky.setAttribute('tabIndex', '0');
        }
      }, 1000);
      this.sticky.querySelectorAll('.header-link').forEach(link => {
        link.setAttribute('tabindex', '0');
      });
    } else {
      this.sticky.classList.remove('sticky');
      this.sticky.parentElement.classList.remove('stuck');
      this.sticky.parentElement.classList.add('unstuck');
      setTimeout(function () {
        const langSelector = document.querySelector('.unstuck .sticky-desktop-header #header_localization_form_language_selector-button');
        const currencySelector = document.querySelector('.unstuck .sticky-desktop-header #header_localization_form_currency_selector-button');

        if (langSelector) {
          langSelector.setAttribute('tabIndex', '-1');
        }

        if (currencySelector) {
          currencySelector.setAttribute('tabIndex', '-1');
        }
      }, 1000);
      this.sticky.querySelectorAll('.header-link').forEach(link => {
        link.setAttribute('tabindex', '-1');
      });
    }

    // If expanded search is enabled, reset expanded search when main header is shown
    const expandedSearchEnabled = this.element.classList.contains('search-expand');
    const searchIsOpen = this.element.querySelector('#top-search-wrapper').classList.contains('expanded');
    if (expandedSearchEnabled && !isSticky && !searchIsOpen) {
      this.sticky.parentElement.classList.add('header-search--expanded');
    }
  };

  loadStickyHeader = () => {
    this.sticky = this.element.querySelector('.sticky-header-wrapper');
    if (!this.sticky) return;

    // copy desktop header
    const desktopHeader = document.getElementById('site-header');
    const desktopHeaderClone = desktopHeader.cloneNode(true);

    const sticky_desktop_header = document.querySelector('.sticky-desktop-header');
    if (sticky_desktop_header) {
      sticky_desktop_header.appendChild(desktopHeaderClone);
    }

    // copy desktop menu
    const desktopMenu = document.querySelector('.header-menu-wrapper');
    const desktopMenuClone = desktopMenu.cloneNode(true);

    const sticky_desktop_menu = document.querySelector('.sticky-desktop-menu');
    if (sticky_desktop_menu) {
      sticky_desktop_menu.appendChild(desktopMenuClone);
    }

    const sticky_search = this.sticky.querySelector('.sticky-header-search').firstElementChild;
    const sticky_icons = this.sticky.querySelector('.header-icons').firstElementChild;
    if (sticky_icons) {
      sticky_icons.appendChild(sticky_search);
    }

    // add in icons if top bar present but hidden in sticky header
    const addTopBarIcons = this.sticky.querySelector('.sticky-hide');
    const topBarIcons = this.sticky.querySelector('.main-icons-with-locale');
    const mainHeader = this.sticky.querySelector('.header-content');
    const searchExpanded = document.querySelector('.logo-placement--center.header-search--expanded .top-bar-enabled');
    const iconContainer = mainHeader.querySelector('.header-icons-container');

    if (searchExpanded) {
      let removeDuplicateSearchBar = searchExpanded.querySelector('#top-search-wrapper').remove();
    }

    if (addTopBarIcons) {
      const topBarIconsClone = topBarIcons.cloneNode(topBarIcons);
      sticky_icons.appendChild(sticky_search);
      iconContainer.appendChild(topBarIconsClone);
    }

    // move main nav inline with icons if sticky logo hidden
    const hideLogo = this.sticky.classList.contains('hide-sticky-logo');
    const stickyLogoContainer = this.sticky.querySelector('.header-logo-container');
    const mainNav = this.sticky.querySelector('#main-navigation-wrapper');
    if (hideLogo) {
      const mainNavClone = mainNav.cloneNode(true);
      stickyLogoContainer.appendChild(mainNavClone);
    }

    // copy mobile menu
    const mobile_menu = document.querySelector('.mobile-header--wrapper');
    const stickyMobileHeader = this.sticky.querySelector(
      '.sticky-mobile-header'
    );

    stickyMobileHeader.appendChild(mobile_menu.cloneNode(true));

    stickyMobileHeader.querySelector('.slide-menu-mobile').addEventListener('click', function () {
      var event = new CustomEvent('mobile:toggle');
      document.querySelector('#theme-menu').dispatchEvent(event);
    });

    var self = this;
    window.addEventListener('scroll', function () {
      self.updateStickyHeader();
      self.previousScrollPosition = window.pageYOffset <= 0 ? 0 : window.pageYOffset;
    });
    this.updateStickyHeader();

    const stickyCartDrawerBtns = this.sticky.querySelectorAll('.slide-menu-cart');

    if (stickyCartDrawerBtns.length) {
      stickyCartDrawerBtns.forEach(btn => {
        btn.addEventListener('click', function () {
          var event = new CustomEvent('cart:toggle');
          document.querySelector('#cartSlideoutWrapper').dispatchEvent(event);
        })
      })
    }
  };

  loadDropdownHover = () => {
    this.dropdownTimeout = null;
    this.touchHoverTimeout = null;
    this.dropdownHandle();
  };

  openMenu = (menu, handler, force = false) => {
    if (!handler.matches('.dropdown-fresh-toggle')) return;

    this.closeAllDropdowns();

    // Align submenu with bottom of the menu
    let offset = menu.offsetHeight + menu.offsetTop;
    let dropdownMenu = menu.querySelector(
      ':scope > .dropdown-menu:not(dropdown-menu--mega)'
    );
    dropdownMenu.style.marginTop = offset + 'px';

    // Align megamenu with bottom of the header
    let el = /** @type {HTMLElement} */ (document.querySelector('.header-wrapper'));
    const sticky = /** @type {HTMLElement} */ (document.querySelector('.sticky'));

    if (sticky) {
      el = /** @type {HTMLElement} */ (document.querySelector('.sticky-header-wrapper'));
    }

    // Place megamenus at the bottom of the header, rather than under their parent menu link.
    let megaOffset = el.offsetTop + el.offsetHeight - 1;
    let notificationBar = /** @type {HTMLElement} */ (document.querySelector('.notification-bar'));

    if (el.matches('.header-wrapper--overlay.unstuck') && notificationBar) {
      megaOffset = megaOffset - notificationBar.offsetHeight;
    }

    if (handler.matches('a') && Helpers.next(handler, 'ul')) {
      handler.setAttribute('aria-expanded', 'true');
    }

    menu.classList.add(force ? 'force-open' : 'open');
    menu.setAttribute('aria-expanded', 'true');

    this.selectMenuDirection(menu);
  };

  closeMenu = (menu) => {
    const allExpanded = menu.querySelectorAll('a[aria-expanded="true"]');

    allExpanded.forEach((expanded) => {
      expanded.setAttribute('aria-expanded', 'false');
    });

    menu.classList.remove('open');
  };

  getMenuFromHandler = (handler) => {
    return handler.matches('.dropdown-fresh-toggle')
      ? handler.parentElement
      : handler;
  };

  handleTouchend = (e, menu) => {
    if (e.type !== 'touchend') return;

    if (this.touchHoverTimeout) {
      clearTimeout(this.touchHoverTimeout);
      this.touchHoverTimeout = null;
    }

    this.element.classList.add('touch-hover');

    if (
      (menu.matches('.dropdown-submenu') ||
        menu.matches('.mega-menu--dropdown-wrapper')) &&
      !menu.classList.contains('open')
    ) {
      // Prevent click on link when dropdown menu is touched and not yet open
      e.preventDefault();
    }
  };

  clearDropdownTimeout = () => {
    if (this.dropdownTimeout) {
      clearTimeout(this.dropdownTimeout);
    }
  };

  handleToggleOnEvents = (e) => {
    e.stopPropagation();

    const handler = e.currentTarget || e.target;
    let menu = this.getMenuFromHandler(handler);

    // Get the <li> not the <a>
    if (menu.classList.contains('dropdown-submenu__link')) {
      menu.setAttribute('aria-expanded', 'true');
      menu = menu.parentElement;
      menu.classList.add('open');
    }

    this.handleTouchend(e, menu);

    // Find neighbours and close them
    let neighbouringMenusOpen = menu
      .closest('.mega-menu--dropdown-wrapper')
      .querySelectorAll('.open');

    if (neighbouringMenusOpen) {
      // Don't close the current open menu.
      const notCurrent = menu.closest('.dropdown-submenu');

      neighbouringMenusOpen.forEach((neighbouringMenuOpen) => {
        if (neighbouringMenuOpen !== notCurrent) {
          neighbouringMenuOpen
            .querySelectorAll('a[aria-expanded="true"]')
            .forEach((expanded) => {
              expanded.setAttribute('aria-expanded', 'false');
            });

          neighbouringMenuOpen.classList.remove('open');
        }
      });
    }

    // wait for some time before opening the menu
    this.clearDropdownTimeout();
    this.dropdownTimeout = setTimeout(this.openMenu, 10, menu, handler);
  };

  handleToggleOffEvents = (e) => {
    if (!e.currentTarget) return;

    // if has children visible, then leave open
    const handler = e.currentTarget;
    const menu = handler.closest('.open');

    if (!menu) {
      this.closeAllDropdowns();
      return;
    }

    if (menu.classList.contains('dropdown-fresh-toggle')) {
      menu.classList.remove('open');
    }

    if (!menu.classList.contains('open')) {
      // Wait a bit then close
      this.clearDropdownTimeout();
      this.dropdownTimeout = setTimeout(this.closeMenu, 750, menu);
    }
  };

  dropdownHandle = () => {
    const dropdownToggles = this.element.querySelectorAll(
      '.dropdown-fresh-toggle, .dropdown-menu > li, .dropdown-menu--mega, .dropdown-menu:not(.dropdown-menu--mega) a.dropdown-submenu__link'
    );

    if (!dropdownToggles) return;

    dropdownToggles.forEach((dropdownToggle) => {
      // open menu/submenu on mousehover
      dropdownToggle.addEventListener('mouseenter', this.handleToggleOnEvents);
      dropdownToggle.addEventListener('touchend', this.handleToggleOnEvents);
      dropdownToggle.addEventListener('focus', this.handleToggleOnEvents);

      // handle closing menu when hover ends
      dropdownToggle.addEventListener('mouseleave', this.handleToggleOffEvents);
      dropdownToggle.addEventListener('blur', this.handleToggleOffEvents);
    });

    document.querySelectorAll('.nav-pills').forEach((navPill) => {
      navPill.addEventListener('mouseleave', this.navigatedFromMenu);
    });

    // hide menu when touched anywhere else than the menu
    document.body.addEventListener('touchstart', this.navigatedFromMenu, { passive: true });
  };

  headerLinkHandle = () => {
    const headerLinks = this.element.querySelectorAll(
      '.header-link:not(.dropdown-fresh-toggle)'
    );

    headerLinks.forEach((headerLink) => {
      headerLink.addEventListener('mouseenter', this.closeAllDropdowns);
      headerLink.addEventListener('touchend', this.closeAllDropdowns);
      headerLink.addEventListener('focus', this.closeAllDropdowns);
    });
  };

  navigatedFromMenu = (e) => {
    if (this.touchHoverTimeout) {
      clearTimeout(this.touchHoverTimeout);
    }
    this.touchHoverTimeout = setTimeout(() => {
      this.touchHoverTimeout = null;
      this.element.classList.remove('touch-hover');
    }, 50);

    const hasOpenParents = Helpers.parents(
      e.target,
      '.mega-menu--dropdown-wrapper.open, .dropdown-submenu.open'
    );

    // don't hide menu if we touched "inside" the menu
    if (e.type === 'mouseleave' || hasOpenParents.length === 0) {
      this.closeAllDropdowns();
    }
  };

  closeAllDropdowns = () => {
    let openMenus = document.querySelectorAll(
      '.mega-menu--dropdown-wrapper.open, .dropdown-submenu.open'
    );

    if (!openMenus) return;

    openMenus.forEach((openMenu) => {
      openMenu.classList.remove('open');

      let expanded = openMenu.querySelectorAll('a[aria-expanded="true"]');

      expanded.forEach((item) => {
        item.classList.remove('open');
        item.setAttribute('aria-expanded', 'false');
      });
    });
  };

  selectMenuDirection = (menu) => {
    // Fix submenu opening outside of viewport by showing it to the left of menu
    const childMenus = menu.querySelectorAll('.dropdown-menu .dropdown-menu');

    if (!childMenus) return;

    // childMenus == NodeList
    Array.prototype.map.call(childMenus, function (childMenu, index) {
      // childMenu = ul.dropdown-menu
      childMenu.style.display = 'block';
      childMenu.style.visibility = 'hidden';

      const width = childMenu.offsetWidth;

      childMenu.style.display = '';
      childMenu.style.visibility = '';

      return width;
    });
  };

  fixHeaderHeight = () => {
    let announcementBarHeight = 0;
    const announcementBar = document.getElementById(
      'shopify-section-announcement-bar'
    );
    if (announcementBar) {
      announcementBarHeight = parseFloat(
        getComputedStyle(announcementBar, null).height.replace('px', '')
      );
    }

    let headerHeight = 0;
    const header = document.querySelector('[data-wetheme-section-type="header"]');
    if (header) {
      headerHeight = parseFloat(
        getComputedStyle(header, null).height.replace('px', '')
      );
    }

    let textAdvertsHeight = 0;
    const textAdverts2 = document.getElementById(
      'shopify-section-text-adverts'
    );
    if (textAdverts2) {
      textAdvertsHeight = parseFloat(
        getComputedStyle(textAdverts2, null).height.replace('px', '')
      );
    }

    const headerHeightCombined =
      announcementBarHeight + headerHeight + textAdvertsHeight;
    const nonOverlayHeight = announcementBarHeight + textAdvertsHeight;

    const slideshowFullScreen = /** @type {HTMLElement} */ (document.querySelector(
      '.homepage-section--slideshow-wrapper .slideshow--full-screen'
    ));
    const headerOverlaysSlideshow = /** @type {HTMLElement} */ (document.querySelector(
      '.header-wrapper--overlay'
    ));

    const indexSections = document.querySelectorAll('.index-sections .shopify-section');

    // If no sections or not on homepage, don't do anything
    if (!indexSections.length) return;

    const topSectionIsSlideshow = indexSections[0].classList.contains('homepage-section--slideshow-wrapper');

    // No need to amend slideshow height unless it's the top section
    if (!topSectionIsSlideshow) return;

    // Only apply if the slideshow is set to full screen size
    if (slideshowFullScreen) {
      // Don't apply the height if the header is overlaid on the slideshow.
      if (headerOverlaysSlideshow) {
        slideshowFullScreen.style.height =
          `calc(100vh - ${nonOverlayHeight}px)`;
        slideshowFullScreen
          .querySelectorAll('ul.slides li')
          .forEach((/** @type {HTMLElement} */ slide) => {
            slide.style.height = `calc(100vh - ${nonOverlayHeight}px)`;
          });
      }
      else {
        slideshowFullScreen.style.height =
          `calc(100vh - ${headerHeightCombined}px)`;
        slideshowFullScreen
          .querySelectorAll('ul.slides li')
          .forEach((/** @type {HTMLElement} */ slide) => {
            slide.style.height = `calc(100vh - ${headerHeightCombined}px)`;
          });
      }
    }
  };

  setSearchWidth = () => {
    const isExpandedSearch = this.element.classList.contains('header-search--expanded');
    const expandedSearchTop = this.element.querySelector('.expanded-search--top');

    // If search is expanded and positioned next to logo, set search box width to the icon container width
    if (isExpandedSearch && expandedSearchTop) {
      const iconContainer = expandedSearchTop.querySelector('.header-icons-container');
      const searchContainer = expandedSearchTop.querySelector('#top-search-wrapper:not(.search-expanded--top-links)');
      if (!searchContainer) return;
      searchContainer.style.width = `${iconContainer.offsetWidth}px`;
    }
  }
}
